/* unplugin-vue-components disabled */import __unplugin_components_2 from 'E:/new-admin/3.0/ruoyi-vue3-cli/src/components/Pagination/index.vue';
import __unplugin_components_1 from 'E:/new-admin/3.0/ruoyi-vue3-cli/src/components/DictTag/index.vue';
import __unplugin_components_0 from 'E:/new-admin/3.0/ruoyi-vue3-cli/src/components/RightToolbar/index.vue';
import { unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, isRef as _isRef, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "app-container"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createTextVNode(" Bean调用示例：ryTask.ryParams('ry') "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("Class类调用示例：com.ruoyi.quartz.task.RyTask.ryParams('ry') "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("参数说明：支持字符串，布尔类型，长整型，浮点型，整型 ")], -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-time el-icon--right"
}, null, -1);
const _hoisted_4 = {
  class: "dialog-footer"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  key: 1
};
const _hoisted_11 = {
  key: 2
};
const _hoisted_12 = {
  key: 3
};
const _hoisted_13 = {
  class: "dialog-footer"
};
import { listJob, getJob, delJob, addJob, updateJob, runJob, changeJobStatus } from "@/api/monitor/job";
export default {
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const {
      proxy
    } = getCurrentInstance();
    const {
      sys_job_group,
      sys_job_status
    } = proxy.useDict("sys_job_group", "sys_job_status");
    const jobList = ref([]);
    const open = ref(false);
    const loading = ref(true);
    const showSearch = ref(true);
    const ids = ref([]);
    const single = ref(true);
    const multiple = ref(true);
    const total = ref(0);
    const title = ref("");
    const openView = ref(false);
    const openCron = ref(false);
    const expression = ref("");
    const data = reactive({
      form: {},
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        jobName: undefined,
        jobGroup: undefined,
        status: undefined
      },
      rules: {
        jobName: [{
          required: true,
          message: "任务名称不能为空",
          trigger: "blur"
        }],
        invokeTarget: [{
          required: true,
          message: "调用目标字符串不能为空",
          trigger: "blur"
        }],
        cronExpression: [{
          required: true,
          message: "cron执行表达式不能为空",
          trigger: "blur"
        }]
      }
    });
    const {
      queryParams,
      form,
      rules
    } = toRefs(data);

    /** 查询定时任务列表 */
    function getList() {
      loading.value = true;
      listJob(queryParams.value).then(response => {
        jobList.value = response.rows;
        total.value = response.total;
        loading.value = false;
      });
    }
    /** 任务组名字典翻译 */
    function jobGroupFormat(row, column) {
      return proxy.selectDictLabel(sys_job_group.value, row.jobGroup);
    }
    /** 取消按钮 */
    function cancel() {
      open.value = false;
      reset();
    }
    /** 表单重置 */
    function reset() {
      form.value = {
        jobId: undefined,
        jobName: undefined,
        jobGroup: undefined,
        invokeTarget: undefined,
        cronExpression: undefined,
        misfirePolicy: 1,
        concurrent: 1,
        status: "0"
      };
      proxy.resetForm("jobRef");
    }
    /** 搜索按钮操作 */
    function handleQuery() {
      queryParams.value.pageNum = 1;
      getList();
    }
    /** 重置按钮操作 */
    function resetQuery() {
      proxy.resetForm("queryRef");
      handleQuery();
    }
    // 多选框选中数据
    function handleSelectionChange(selection) {
      ids.value = selection.map(item => item.jobId);
      single.value = selection.length != 1;
      multiple.value = !selection.length;
    }
    // 更多操作触发
    function handleCommand(command, row) {
      switch (command) {
        case "handleRun":
          handleRun(row);
          break;
        case "handleView":
          handleView(row);
          break;
        case "handleJobLog":
          handleJobLog(row);
          break;
        default:
          break;
      }
    }
    // 任务状态修改
    function handleStatusChange(row) {
      let text = row.status === "0" ? "启用" : "停用";
      proxy.$modal.confirm('确认要"' + text + '""' + row.jobName + '"任务吗?').then(function () {
        return changeJobStatus(row.jobId, row.status);
      }).then(() => {
        proxy.$modal.msgSuccess(text + "成功");
      }).catch(function () {
        row.status = row.status === "0" ? "1" : "0";
      });
    }
    /* 立即执行一次 */
    function handleRun(row) {
      proxy.$modal.confirm('确认要立即执行一次"' + row.jobName + '"任务吗?').then(function () {
        return runJob(row.jobId, row.jobGroup);
      }).then(() => {
        proxy.$modal.msgSuccess("执行成功");
      }).catch(() => {});
    }
    /** 任务详细信息 */
    function handleView(row) {
      getJob(row.jobId).then(response => {
        form.value = response.data;
        openView.value = true;
      });
    }
    /** cron表达式按钮操作 */
    function handleShowCron() {
      expression.value = form.value.cronExpression;
      openCron.value = true;
    }
    /** 确定后回传值 */
    function crontabFill(value) {
      form.value.cronExpression = value;
    }
    /** 任务日志列表查询 */
    function handleJobLog(row) {
      const jobId = row.jobId || 0;
      router.push({
        path: "/monitor/job-log/index",
        query: {
          jobId: jobId
        }
      });
    }
    /** 新增按钮操作 */
    function handleAdd() {
      reset();
      open.value = true;
      title.value = "添加任务";
    }
    /** 修改按钮操作 */
    function handleUpdate(row) {
      reset();
      const jobId = row.jobId || ids.value;
      getJob(jobId).then(response => {
        form.value = response.data;
        open.value = true;
        title.value = "修改任务";
      });
    }
    /** 提交按钮 */
    function submitForm() {
      proxy.$refs["jobRef"].validate(valid => {
        if (valid) {
          if (form.value.jobId != undefined) {
            updateJob(form.value).then(response => {
              proxy.$modal.msgSuccess("修改成功");
              open.value = false;
              getList();
            });
          } else {
            addJob(form.value).then(response => {
              proxy.$modal.msgSuccess("新增成功");
              open.value = false;
              getList();
            });
          }
        }
      });
    }
    /** 删除按钮操作 */
    function handleDelete(row) {
      const jobIds = row.jobId || ids.value;
      proxy.$modal.confirm('是否确认删除定时任务编号为"' + jobIds + '"的数据项?').then(function () {
        return delJob(jobIds);
      }).then(() => {
        getList();
        proxy.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    }
    /** 导出按钮操作 */
    function handleExport() {
      proxy.download("monitor/job/export", {
        ...queryParams.value
      }, `job_${new Date().getTime()}.xlsx`);
    }
    getList();
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_col = _resolveComponent("el-col");
      const _component_right_toolbar = __unplugin_components_0;
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_dict_tag = __unplugin_components_1;
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_table = _resolveComponent("el-table");
      const _component_pagination = __unplugin_components_2;
      const _component_question_filled = _resolveComponent("question-filled");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_radio_button = _resolveComponent("el-radio-button");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createVNode(_component_el_form, {
        model: _unref(queryParams),
        ref: "queryRef",
        inline: true,
        "label-width": "68px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "任务名称",
          prop: "jobName"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(queryParams).jobName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(queryParams).jobName = $event),
            placeholder: "请输入任务名称",
            clearable: "",
            onKeyup: _withKeys(handleQuery, ["enter"])
          }, null, 8, ["modelValue", "onKeyup"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "任务组名",
          prop: "jobGroup"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _unref(queryParams).jobGroup,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(queryParams).jobGroup = $event),
            placeholder: "请选择任务组名",
            clearable: ""
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sys_job_group), dict => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: dict.value,
                label: dict.label,
                value: dict.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "任务状态",
          prop: "status"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _unref(queryParams).status,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(queryParams).status = $event),
            placeholder: "请选择任务状态",
            clearable: ""
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sys_job_status), dict => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: dict.value,
                label: dict.label,
                value: dict.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            icon: "Search",
            onClick: handleQuery
          }, {
            default: _withCtx(() => [_createTextVNode("搜索")]),
            _: 1
          }), _createVNode(_component_el_button, {
            icon: "Refresh",
            onClick: resetQuery
          }, {
            default: _withCtx(() => [_createTextVNode("重置")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), [[_vShow, _unref(showSearch)]]), _createVNode(_component_el_row, {
        gutter: 10,
        class: "mb8"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 1.5
        }, {
          default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
            type: "primary",
            plain: "",
            icon: "Plus",
            onClick: handleAdd
          }, {
            default: _withCtx(() => [_createTextVNode("新增")]),
            _: 1
          })), [[_directive_hasPermi, ['monitor:job:add']]])]),
          _: 1
        }, 8, ["span"]), _createVNode(_component_el_col, {
          span: 1.5
        }, {
          default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
            type: "success",
            plain: "",
            icon: "Edit",
            disabled: _unref(single),
            onClick: handleUpdate
          }, {
            default: _withCtx(() => [_createTextVNode("修改")]),
            _: 1
          }, 8, ["disabled"])), [[_directive_hasPermi, ['monitor:job:edit']]])]),
          _: 1
        }, 8, ["span"]), _createVNode(_component_el_col, {
          span: 1.5
        }, {
          default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
            type: "danger",
            plain: "",
            icon: "Delete",
            disabled: _unref(multiple),
            onClick: handleDelete
          }, {
            default: _withCtx(() => [_createTextVNode("删除")]),
            _: 1
          }, 8, ["disabled"])), [[_directive_hasPermi, ['monitor:job:remove']]])]),
          _: 1
        }, 8, ["span"]), _createVNode(_component_el_col, {
          span: 1.5
        }, {
          default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
            type: "warning",
            plain: "",
            icon: "Download",
            onClick: handleExport
          }, {
            default: _withCtx(() => [_createTextVNode("导出")]),
            _: 1
          })), [[_directive_hasPermi, ['monitor:job:export']]])]),
          _: 1
        }, 8, ["span"]), _createVNode(_component_el_col, {
          span: 1.5
        }, {
          default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
            type: "info",
            plain: "",
            icon: "Operation",
            onClick: handleJobLog
          }, {
            default: _withCtx(() => [_createTextVNode("日志")]),
            _: 1
          })), [[_directive_hasPermi, ['monitor:job:query']]])]),
          _: 1
        }, 8, ["span"]), _createVNode(_component_right_toolbar, {
          showSearch: _unref(showSearch),
          "onUpdate:showSearch": _cache[3] || (_cache[3] = $event => _isRef(showSearch) ? showSearch.value = $event : null),
          onQueryTable: getList
        }, null, 8, ["showSearch"])]),
        _: 1
      }), _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: _unref(jobList),
        onSelectionChange: handleSelectionChange
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          type: "selection",
          width: "55",
          align: "center"
        }), _createVNode(_component_el_table_column, {
          label: "任务编号",
          width: "100",
          align: "center",
          prop: "jobId"
        }), _createVNode(_component_el_table_column, {
          label: "任务名称",
          align: "center",
          prop: "jobName",
          "show-overflow-tooltip": true
        }), _createVNode(_component_el_table_column, {
          label: "任务组名",
          align: "center",
          prop: "jobGroup"
        }, {
          default: _withCtx(scope => [_createVNode(_component_dict_tag, {
            options: _unref(sys_job_group),
            value: scope.row.jobGroup
          }, null, 8, ["options", "value"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "调用目标字符串",
          align: "center",
          prop: "invokeTarget",
          "show-overflow-tooltip": true
        }), _createVNode(_component_el_table_column, {
          label: "cron执行表达式",
          align: "center",
          prop: "cronExpression",
          "show-overflow-tooltip": true
        }), _createVNode(_component_el_table_column, {
          label: "状态",
          align: "center"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_switch, {
            modelValue: scope.row.status,
            "onUpdate:modelValue": $event => scope.row.status = $event,
            "active-value": "0",
            "inactive-value": "1",
            onChange: $event => handleStatusChange(scope.row)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作",
          align: "center",
          width: "200",
          "class-name": "small-padding fixed-width"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_tooltip, {
            content: "修改",
            placement: "top"
          }, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
              type: "primary",
              link: "",
              icon: "Edit",
              onClick: $event => handleUpdate(scope.row)
            }, null, 8, ["onClick"]), [[_directive_hasPermi, ['monitor:job:edit']]])]),
            _: 2
          }, 1024), _createVNode(_component_el_tooltip, {
            content: "删除",
            placement: "top"
          }, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
              type: "primary",
              link: "",
              icon: "Delete",
              onClick: $event => handleDelete(scope.row)
            }, null, 8, ["onClick"]), [[_directive_hasPermi, ['monitor:job:remove']]])]),
            _: 2
          }, 1024), _createVNode(_component_el_tooltip, {
            content: "执行一次",
            placement: "top"
          }, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
              type: "primary",
              icon: "CaretRight",
              link: "",
              onClick: $event => handleRun(scope.row)
            }, null, 8, ["onClick"]), [[_directive_hasPermi, ['monitor:job:changeStatus']]])]),
            _: 2
          }, 1024), _createVNode(_component_el_tooltip, {
            content: "任务详细",
            placement: "top"
          }, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
              type: "primary",
              link: "",
              icon: "View",
              onClick: $event => handleView(scope.row)
            }, null, 8, ["onClick"]), [[_directive_hasPermi, ['monitor:job:query']]])]),
            _: 2
          }, 1024), _createVNode(_component_el_tooltip, {
            content: "调度日志",
            placement: "top"
          }, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
              type: "primary",
              link: "",
              icon: "Operation",
              onClick: $event => handleJobLog(scope.row)
            }, null, 8, ["onClick"]), [[_directive_hasPermi, ['monitor:job:query']]])]),
            _: 2
          }, 1024)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])), [[_directive_loading, _unref(loading)]]), _withDirectives(_createVNode(_component_pagination, {
        total: _unref(total),
        page: _unref(queryParams).pageNum,
        "onUpdate:page": _cache[4] || (_cache[4] = $event => _unref(queryParams).pageNum = $event),
        limit: _unref(queryParams).pageSize,
        "onUpdate:limit": _cache[5] || (_cache[5] = $event => _unref(queryParams).pageSize = $event),
        onPagination: getList
      }, null, 8, ["total", "page", "limit"]), [[_vShow, _unref(total) > 0]]), _createVNode(_component_el_dialog, {
        title: _unref(title),
        modelValue: _unref(open),
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => _isRef(open) ? open.value = $event : null),
        width: "800px",
        "append-to-body": ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitForm
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: cancel
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref: "jobRef",
          model: _unref(form),
          rules: _unref(rules),
          "label-width": "120px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "任务名称",
                prop: "jobName"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).jobName,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(form).jobName = $event),
                  placeholder: "请输入任务名称"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "任务分组",
                prop: "jobGroup"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: _unref(form).jobGroup,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _unref(form).jobGroup = $event),
                  placeholder: "请选择"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sys_job_group), dict => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: dict.value,
                      label: dict.label,
                      value: dict.value
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                prop: "invokeTarget"
              }, {
                label: _withCtx(() => [_createElementVNode("span", null, [_createTextVNode(" 调用方法 "), _createVNode(_component_el_tooltip, {
                  placement: "top"
                }, {
                  content: _withCtx(() => [_hoisted_2]),
                  default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [_createVNode(_component_question_filled)]),
                    _: 1
                  })]),
                  _: 1
                })])]),
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).invokeTarget,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _unref(form).invokeTarget = $event),
                  placeholder: "请输入调用目标字符串"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "cron表达式",
                prop: "cronExpression"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).cronExpression,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _unref(form).cronExpression = $event),
                  placeholder: "请输入cron执行表达式"
                }, {
                  append: _withCtx(() => [_createVNode(_component_el_button, {
                    type: "primary",
                    onClick: handleShowCron
                  }, {
                    default: _withCtx(() => [_createTextVNode(" 生成表达式 "), _hoisted_3]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "执行策略",
                prop: "misfirePolicy"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                  modelValue: _unref(form).misfirePolicy,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _unref(form).misfirePolicy = $event)
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_radio_button, {
                    label: "1"
                  }, {
                    default: _withCtx(() => [_createTextVNode("立即执行")]),
                    _: 1
                  }), _createVNode(_component_el_radio_button, {
                    label: "2"
                  }, {
                    default: _withCtx(() => [_createTextVNode("执行一次")]),
                    _: 1
                  }), _createVNode(_component_el_radio_button, {
                    label: "3"
                  }, {
                    default: _withCtx(() => [_createTextVNode("放弃执行")]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "是否并发",
                prop: "concurrent"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                  modelValue: _unref(form).concurrent,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _unref(form).concurrent = $event)
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_radio_button, {
                    label: "0"
                  }, {
                    default: _withCtx(() => [_createTextVNode("允许")]),
                    _: 1
                  }), _createVNode(_component_el_radio_button, {
                    label: "1"
                  }, {
                    default: _withCtx(() => [_createTextVNode("禁止")]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "状态"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                  modelValue: _unref(form).status,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _unref(form).status = $event)
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sys_job_status), dict => {
                    return _openBlock(), _createBlock(_component_el_radio, {
                      key: dict.value,
                      label: dict.value
                    }, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(dict.label), 1)]),
                      _: 2
                    }, 1032, ["label"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["title", "modelValue"]), _createVNode(_component_el_dialog, {
        title: "任务详细",
        modelValue: _unref(openView),
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => _isRef(openView) ? openView.value = $event : null),
        width: "700px",
        "append-to-body": ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_button, {
          onClick: _cache[14] || (_cache[14] = $event => openView.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("关 闭")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: _unref(form),
          "label-width": "120px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "任务编号："
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(form).jobId), 1)]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "任务名称："
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(form).jobName), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "任务分组："
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(jobGroupFormat(_unref(form))), 1)]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "创建时间："
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(form).createTime), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "cron表达式："
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(form).cronExpression), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "下次执行时间："
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.parseTime(_unref(form).nextValidTime)), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "调用目标方法："
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(form).invokeTarget), 1)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "任务状态："
              }, {
                default: _withCtx(() => [_unref(form).status == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, "正常")) : _unref(form).status == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_6, "失败")) : _createCommentVNode("", true)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "是否并发："
              }, {
                default: _withCtx(() => [_unref(form).concurrent == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, "允许")) : _unref(form).concurrent == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_8, "禁止")) : _createCommentVNode("", true)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "执行策略："
              }, {
                default: _withCtx(() => [_unref(form).misfirePolicy == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, "默认策略")) : _unref(form).misfirePolicy == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_10, "立即执行")) : _unref(form).misfirePolicy == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_11, "执行一次")) : _unref(form).misfirePolicy == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_12, "放弃执行")) : _createCommentVNode("", true)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};